var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#138282;stroke:#138282;stroke-width:2px;}.b{fill:#fff;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.292)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 20,
    cy: 20,
    r: 19
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z",
    transform: "translate(2.002 2.292)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ab6786528c81ed201596848b0be5e0f4.svg";
export { ForwardRef as ReactComponent };